module.exports = __webpack_public_path__ + "img/address-bg.32c1bbdb.png";